import React, { useContext } from "react";
import { Button, Col, Container, Modal, Row, Stack } from "react-bootstrap";
import menuLookup from "../../../assets/images/menuLookup.svg";
import headerLogo from "../../../assets/images/Sprayzapp-logo-final-black.png";
import userLogo from "../../../assets/images/usericon.png";
import "./Header.css";
import { useState } from "react";
import { UserContext } from "../../../App";

function Header() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const user = useContext(UserContext);
  return (
    <Row className="header">
      <Col className="item-padding">
        <img src={headerLogo} alt={"header-icon"} width={"120px"} />
      </Col>
      <Col className="menu-position-right item-padding">
        <Row style={{ width: "50px", height: "25px" }}>
          <img src={userLogo} alt={"menu-icon"} />
        </Row>
        <Row style={{ padding: "0px 15px" }}>
          <span style={{ textTransform: "capitalize" }}>
            {" "}
            {user["firstName"]
              ? user["firstName"] + " " + user["lastName"]
              : ""}{" "}
          </span>
        </Row>
      </Col>
    </Row>
  );
}

export default Header;
